import EventEmitter from './EventEmitter'

const MAX_PIXEL_RATIO = 2.5

function getPixelRatio(): number {
  return Math.min(window.devicePixelRatio || 1, MAX_PIXEL_RATIO)
}

/** Tracks viewport size + pixel ratio and emits `resize`. */
export default class Sizes extends EventEmitter {
  public width: number
  public height: number
  public pixelRatio: number

  constructor() {
    super()

    this.width = window.innerWidth
    this.height = window.innerHeight
    this.pixelRatio = getPixelRatio()

    window.addEventListener('resize', this.onResize)
  }

  private onResize = (): void => {
    this.width = window.innerWidth
    this.height = window.innerHeight
    this.pixelRatio = getPixelRatio()
    this.trigger('resize')
  }
}
